import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-footer-type01',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink],
  templateUrl: './footer-type01.component.html',
  styleUrl: './footer-type01.component.scss'
})
export class FooterType01Component implements OnInit {

  public view: any = {}

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef) {

    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });

    this._tfmService.getDestinations().then(res => {
      this.view.destinations = res;
      this._tfmService.log('Get Destinations: ', res);
    });

    this._tfmService.getPages().then((res: any) => {
      this.view.pages = res.content.filter(x => !(x.section === 'about' || x.section === 'contact' || x.section === 'xl-howzit-promo' || x.section === 'corporate-travel' || x.section === 'leisure-travel' || x.section === 'team' || x.section === 'non-profit' || x.section === 'events'));
      // this.view.pages = res;
      // this._tfmService.log(res);
    });
  }

  get currentYear(): number {
    return new Date().getFullYear();
  };

  ngOnInit(): void {
  }
}
